<template>
    <section>
      <div class="w-full bg-white rounded-md mt-2 p-4">
        <div class="w-full flex gap-2 items-center">
          <i class="pi pi-list"></i>
          <p class="text-lg font-bold">Listado de Médicos</p>
          <Button @click="displayModalMedico = true, idMed = null" class="ml-auto rounded-md" label="Crear Médico" />
        </div>
        <div class="grid grid-cold-1 md:grid-cols-2 lg:grid-cols-5 gap-2 my-2">
          <!-- filtro por Municipio -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="mun">Registro Médico</label>
            <InputText class="w-full" id="mun" @keyup.enter="listarMedicos" v-model="filtros.RegMedico" />
          </div>
          <!-- filtro por Departamento -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="dep">Nombre Médico</label>
            <InputText class="w-full" id="dep" @keyup.enter="listarMedicos" v-model="filtros.NomMedico"/>
          </div>
          <div class="flex gap-2">
            <Button @click="listarMedicos" class="mt-5 mb-1.5 rounded-md" label="Buscar" />
            <Button @click="limpiarFiltros" class="mt-5 mb-1.5 rounded-md p-button-outlined p-button-secondary" label="Limpiar" />
          </div>
        </div>
        <div class="w-full my-2">
          <DataTable class="p-datatable-sm text-xs" :value="medicos.rows" responsiveLayout="scroll">
            <Column header="Registro Médico">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ data.RegMedico }}</p>
                  <div class="flex gap-x-4 hover:text-blue-600 text-white transition ease-in-out duration-500">
                    <button class="underline italic" @click='EditMed(data.RegMedico)'>Editar</button>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="NomMedico" header="Nombre médico"></Column>

            <Column header="Acción">
              <template #body="{data}">
                <div class="p-2 rounded-md text-center" >
                  <Button
                      @click='DeleteMed(data.RegMedico)'
                      severity="danger"
                      v-tooltip="'Inactivar'"
                      class='p-button-rounded p-button-icon-only mx-2'
                  >
                    <i class="pi pi-trash text-white"></i>
                  </Button>
                </div>
              </template>
            </Column>
          </DataTable>
          <Paginator v-model:first="offset"
            :rows="limit"
            :totalRecords="parseInt(medicos.count)"
            :rowsPerPageOptions="[2,10,20,30,100]"
            @page="onPage($event)"
          />
        </div>
      </div>
      <Dialog :header="`${idMed ? 'Actualizar' : 'Crear'} Médico`" v-model:visible="displayModalMedico" :breakpoints="{'960px': '95vw'}" :style="{width: '60vw'}" :modal="true">
        <div class="grid gap-4 bg-white dark:bg-dark-1 dark:text-gray-500 w-full sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 xxl:grid-cols-5">
          <div class="sm:col-span-2 lg:col-span-5 xl:col-span-5 xxl:col-span-5">
            <crearMedico @crearMed="displayModalMedico = false, listarMedicos()" :idMed="idMed" />
          </div>
        </div>
      </Dialog>
      <Toast />
    </section>
</template>
<script setup>
  import { useToast } from 'primevue/usetoast'
  import Swal from 'sweetalert2'
  import MedicosService from '../../../../../services/medico.service'
  import { onMounted, ref, computed } from 'vue'
  import crearMedico from './crear.vue'
    // name: 'ListadoOrdenesVenta'
    // Servicios
    const toast = useToast()
    const _MedicosService = ref(new MedicosService())
    // Referencias
    const medicos = ref([])
    const MedSeleccionada = ref()
    const limit = ref(10)
    const offset = ref(0)
    const filtros = ref({
      RegMedico: null,
      NomMedico: null
    })
    const idMed = ref(null)
    const displayModalMedico = ref(false)
    const params = computed(() => {
      return {
        limit: limit.value,
        offset: offset.value,
        ...filtros.value
      }
    })
    // Metodos
    const onPage = ({ first, page, pageCount, rows }) => {
      limit.value = rows
      listarMedicos(params.value)
    }
    const listarMedicos = () => {
      const object = {
        ...params.value,
        limit: limit.value,
        offset: offset.value
      }
      _MedicosService.value.paginate(object).then(({ data }) => {
        medicos.value = data
      })
    }
    const EditMed = (id) => {
      displayModalMedico.value = true
      idMed.value = id
    }
    const DeleteMed = (id) => {
      Swal.fire({
          title: 'Esta seguro de eliminar este médico?',
          showDenyButton: true,
          denyButtonText: 'Cancelar',
          confirmButtonText: 'Eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
            _MedicosService.value.eliminarMed(id).then(({ data }) => {
              if (data.error) {
                console.error('Error al eliminar el médico, por favor intente nuevamente')
              } else {
                toast.add({ severity: 'success', summary: 'Exito', detail: 'médico eliminado exitosamente', life: 3000 })
              }
              listarMedicos()
            })
          } else if (result.isDenied) {
            Swal.fire('médico no eliminado', '', 'info')
          }
        })
    }
    const limpiarFiltros = () => {
      filtros.value = {
        nomMpio: null,
        nomDpto: null
      }
      MedSeleccionada.value = ''
      listarMedicos()
    }
    onMounted(() => {
      listarMedicos()
    })
</script>
<style>
  .p-dropdown-label{
    font-size: 0.75rem !important
  }
  .tipoId .p-dropdown-trigger {
    display: none !important;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(189, 189, 189);
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ::-webkit-input-placeholder { /* Edge */
    color: gray;
  }
  ::-webkit-scrollbar {
    width: 0.4rem;
  }
</style>
